module.exports = __webpack_public_path__ + "static/media/25sqm with closet.5e7ce814.JPG";